/**
 * Pixel burst: when a visitor presses an add-to-cart button, a dozen small squares in the
 * brand colours pop out of it for under a second. Purely visual: it never delays or blocks
 * the add to cart. Skipped for visitors who prefer reduced motion. Loaded only when
 * Theme settings → "Pixel decorations" → "Pixel burst" is on.
 */
(function () {
  if (window.__kgPixelBurst) return;
  window.__kgPixelBurst = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SELECTOR = '[id^="ProductSubmitButton-"], .sticky-atc-button';
  var COUNT = 12;

  function colours() {
    var styles = getComputedStyle(document.documentElement);
    return ['--kg-px-1', '--kg-px-2', '--kg-px-3']
      .map(function (name) {
        return styles.getPropertyValue(name).trim();
      })
      .filter(Boolean);
  }

  function burst(button) {
    var rect = button.getBoundingClientRect();
    // The sticky bar clicks the (off-screen) main button too: only burst where the visitor looks.
    if (rect.bottom < 0 || rect.top > window.innerHeight || rect.width === 0) return;
    var palette = colours();
    if (!palette.length) return;
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;

    for (var i = 0; i < COUNT; i++) {
      var square = document.createElement('span');
      var angle = (Math.PI * 2 * i) / COUNT + Math.random() * 0.4;
      var distance = 40 + Math.random() * 50;
      square.className = 'kg-burst';
      square.setAttribute('aria-hidden', 'true');
      square.style.left = originX + Math.cos(angle) * (rect.width / 4) + 'px';
      square.style.top = originY + Math.sin(angle) * (rect.height / 4) + 'px';
      square.style.background = palette[i % palette.length];
      square.style.setProperty('--kg-dx', Math.cos(angle) * distance + 'px');
      square.style.setProperty('--kg-dy', Math.sin(angle) * distance + 'px');
      square.style.setProperty('--kg-rot', Math.round(Math.random() * 180 - 90) + 'deg');
      square.addEventListener('animationend', function (event) {
        event.target.remove();
      });
      document.body.appendChild(square);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (reduceMotion.matches) return;
      var button = event.target.closest && event.target.closest(SELECTOR);
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      burst(button);
    },
    true
  );
})();
